<ng-container *ngIf="currentZone==='true'">
	<ng-container *ngIf="mobileView">
		<div class="text-truncate" style="font-size: 12px; max-width: 250px; margin-left: 5px; color:#000;">({{user.ZoneDisplayName}})</div>
	</ng-container>

	<ng-container *ngIf="!mobileView">
		<div class="text-truncate rounded mx-auto" style="font-size: 10px; max-width: 200px; background-color: #fff; color: #000; padding: 0px 3px;">{{user.ZoneDisplayName}}</div>
	</ng-container>
</ng-container>

<ng-container *ngIf="canSwitch && currentZone==='false'">
	<hr />
	<div style="margin-left:10px">
		<div [ngStyle]="{'color':(mobileView?'#000':'#7f8c8d')}" style="padding:8px 0px;">Switch Accounts</div>
		<table class="table table-borderless">
			<colgroup><col style="width:20px;" /><col /></colgroup>
			<tr *ngFor="let zone of oAccounts;">
				<td>
					<div [ngStyle]="{'color':(mobileView?'#000':'#7f8c8d')}">{{zone.Zone}}</div>
					<ul style="padding-left: 15px;">
						<li *ngFor="let acc of zone.Accounts;" (click)="changeAccount(acc.PersonId)" role="button"  [ngClass]="mobileView?'text-primary':'text-jmDropdownItem'">
							{{acc.Role}}
						</li>
					</ul>
				</td>
			</tr>
		</table>
	</div>
	<hr />
</ng-container>
